// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3nQx8","actions":"styles_actions__2LCZ9","username":"styles_username__3s5nh","title":"styles_title__sbw5I"};